import {logo} from '../images'
export const schoolData = [
  {
    learningTitle:"Web Dev",
    logo:logo,
    path:"Full Stack JavaScript",
    about:"This path takes you through our entire JavaScript curriculum. You'll learn everything you need to know to create beautiful responsive websites from scratch using Html, Css, JavaScript, NodeJs and MongoDb.",
    aboutPopUp:[
      {
        name:"social-cultural",
        details1:"This is a combination of but sociology or Social system and In sociology, social system is the patterned network of relationships constituting a coherent whole that exist between individuals, groups, and institutions. It is the formal structure of role and status that can form in a small, stable group. ",
        details2:"A cultural system is the interaction of different elements in culture. While a cultural system is very different from a social system, sometimes both systems together are referred to as the sociocultural system.",
        // details3:"PayScale reports the average salary at $75,310 per year, with a low of $50K and a high of $90K. PayScale’s numbers are based on 4,206 salary profiles submitted by frontend developers.",
        // details4:"ZipRecruiter says that the average frontend developer salary is $94,639 per year, with a low of $37K and a high of $147K.",
        // details5:"Bas
        sourceLink:"https://en.wikipedia.org/wiki/Religion",
        //
        // status:"",
        // jobLocation:"",

      }

    ],
    aboutSourceLink:{
                      name:"Read more",
                      link:"https://en.wikipedia.org/wiki/Religion"
                    },
    MainLocation:"Cameroon || southwest || Buea",
    TotalNumberOfBranches:"2",
    OtherLocations:[
      {
        name:"Remote",
        link:"https://msb-geneasocial.herokuapp.com/"
      }
    ],
    JobPost:[
      {
        name:"Front End Developer",
        location:"Remote/US",
        details:" The average salary for a Front End Developer in US is $105,241 per year. The average additional cash compensation for a Front End Developer in US is $11,401. The average total compensation for a Front End Developer in US is $116,642. Front End Developer salaries are based on responses gathered by Built In from anonymous Front End Developer employees in US.",
        analysis:{

            status:"Dynamic",
            jobLocation:"Remote",
            details1:"According to Glassdoor, the average frontend developer salary is $86,013. That amount is based on 3,715 salaries submitted by frontend developers to Glassdoor. The lowest frontend developer salary is around $51K, while the highest is $145K.",
            details2:"Indeed lists a slightly higher salary, but their sample size is also larger than Glassdoor’s. They say the average frontend developer salary is $103,832, with an average $2,500 yearly cash bonus.",
            details3:"PayScale reports the average salary at $75,310 per year, with a low of $50K and a high of $90K. PayScale’s numbers are based on 4,206 salary profiles submitted by frontend developers.",
            details4:"ZipRecruiter says that the average frontend developer salary is $94,639 per year, with a low of $37K and a high of $147K.",
            details5:"Based on the numbers above, we can deduce that the average frontend developer salary is $89,948 per year — which is nothing to scoff at."
        },
      },

      {
        name:"Back End Developer",
        location:"Remote/US",
        details:" The average salary for a Back End Developer in US is $96,783 per year.",
        analysis:{

            status:"Dynamic",
            jobLocation:"Remote",
            details1:"Knowledge of advanced programming languages such as Java, C#, Visual Basic, Ruby, and Python. Often, you’ll also need to know PHP and JavaScript. Knowledge of relevant frameworks such as Laravel, Django, Node.js, and similar Working knowledge of databases such as Oracle, MySQL, or Microsoft SQL Server Knowledge of data structures and algorithms Knowing API and ORM if you want to get involved with mobile backend development.",
            details2:"According to Glassdoor, the average base pay for a backend developer is $80,713, calculated from 200 salaries submitted anonymously to Glassdoor. The lowest salary submitted was around $48K, while the highest was about $132K.",
            details3:"Indeed reports a higher number at $118,856 per year based on 2,200 salaries. Indeed also notes that you can expect a $4,000 bonus each year as a backend developer.",
            details4:"PayScale’s numbers are closer to Glassdoor’s and report an average backend developer salary of $81,161 per year. This number was based on 58 salaries submitted to PayScale anonymously. The lowest salary as per PayScale is $51K, and the highest is $131K.",
            details5:"On the other hand, ZipRecruiter lists the average backend developer salary at $83,770 per year, with the low end being $33,500 and the high end reaching $149K.",
            details6:"Based on these numbers, the average salary for a backend developer is $90,826 per year."
        },
      },

      {
        name:"Full Stack Developer",
        location:"Remote/US",
        details:" The average salary for a Full Stack Developer in US is $101,914 per year. ",
        analysis:{

            status:"Dynamic",
            jobLocation:"Remote",
            details1:"Generally, a website comprises two parts: the frontend (client-side) and the backend (server-side). The front end is what you see when you visit a site, and it includes HTML, CSS, and other languages like Javascript. While web designers are often responsible for the finer artistic aspects, developing a front end still requires being detail-oriented and balancing function and beauty. As for the backend, this includes all the operations going on invisibly in the background. A variety of languages like PHP, Ruby, and Python, and the various frameworks that go with them — though, backend developers tend to specialize in a select handful. Many backend developers are also responsible for managing the database and debugging any server-side issues that may occur. So, where do full-stack developers come into this? The answer: they specialize in everything! A full-stack developer can deal with problems on both the client- and server-side and set up a working website all by themselves. However, that doesn’t mean full-stack developers make front or backend developers obsolete, and you certainly shouldn’t expect to be fulfilling large projects all on your own. Full-stack development is a less specialized job, but it means you’re familiar with every step of web development. On the other hand, spreading your skills across a wide area means you’re often missing out on developing crucial skills, or half of your skillset may become unbalanced as you focus on specific areas. Still, being a full-stack developer has enormous advantages as it makes you highly flexible and able to work on different parts of a project as needed.",
            details2:"Indeed: $108k/year, based on 10.5k reported salaries",
            details3:" $99k/year, with a low of $63k and a high of $157k",
            details4:"$103k/year ($49/hour), with a low of $38k and a high of $159k",
            details5:"$79k/year, with a low of $54k and a high of $115k",
            details6:"Averaging all this data, you get an annual salary of $97k/year. "
        },
      },

    ],
    JobPostSources:[
      {
        name:"builtin.com",
        link:"https://builtin.com/salaries/dev-engineer/front-end-developer"
      },
      {
        name:"kinsta.com/frontend",
        link:"https://kinsta.com/blog/front-end-developer-salary/"
      },
      {
        name:"kinsta.com/backend",
        link:"https://kinsta.com/blog/back-end-developer-salary/"
      },
      {
        name:"kinsta.com/fullstack",
        link:"https://kinsta.com/blog/full-stack-developers-salary/"
      }
    ],
    courseLink:"/school/devcourse"

  },
  {
      learningTitle:"Rel Studies",
      logo:logo,
      path:"Study of comparative religion",
      about:"According to Wikipedia, Religion is usually defined as a social-cultural system of designated behaviors and practices, morals, beliefs, worldviews, texts, sanctified places, prophecies, ethics, or organizations, that generally relates humanity to supernatural, transcendental, and spiritual elements however, there is no scholarly consensus over what precisely constitutes a religion",
      aboutPopUp:[
        {
          name:"social-cultural",
          details1:"This is a combination of but sociology or Social system and In sociology, social system is the patterned network of relationships constituting a coherent whole that exist between individuals, groups, and institutions. It is the formal structure of role and status that can form in a small, stable group. ",
          details2:"A cultural system is the interaction of different elements in culture. While a cultural system is very different from a social system, sometimes both systems together are referred to as the sociocultural system.",
          popUpSources:[
            {
              name:"social-cultural",
              link:"https://en.wikipedia.org/wiki/Religion",
            },
          ],


        },
        {
          name:"designated behaviors or Religious behaviours ",
          details1:"Religious behaviours are behaviours motivated by religious beliefs. Religious actions are also called 'ritual' and religious avoidances are called taboos or ritual prohibitions.",
          details2:"The two best known religious actions are prayer and sacrifice. ",
            // details3:"PayScale reports the average salary at $75,310 per year, with a low of $50K and a high of $90K. PayScale’s numbers are based on 4,206 salary profiles submitted by frontend developers.",
          // details4:"ZipRecruiter says that the average frontend developer salary is $94,639 per year, with a low of $37K and a high of $147K.",
          // details5:"Bas
          popUpSources:[
            {
              name:"designated behaviors or Religious behaviours",
              link:"https://en.wikipedia.org/wiki/Religious_behaviour",
            },
          ],

        }
        ,
        {
          name:"Morality",
          details1:"Morality (from Latin moralitas 'manner, character, proper behavior') is the differentiation of intentions, decisions and actions between those that are distinguished as proper (right) and those that are improper (wrong).",
          details2:" Morality can be a body of standards or principles derived from a code of conduct from a particular philosophy, religion or culture, or it can derive from a standard that a person believes should be universal.",
            details3:'Morality may also be specifically synonymous with "goodness" or "rightness"',
          // details4:"ZipRecruiter says that the average frontend developer salary is $94,639 per year, with a low of $37K and a high of $147K.",
          // details5:"Bas
          popUpSources:[
            {
              name:"designated behaviors or Religious behaviours",
              link:"https://en.wikipedia.org/wiki/Religious_behaviour",
            },
          ],

        }
        ,
        {
          name:"Belief",
          details1:"A belief is an attitude that something is the case, or that some proposition about the universe is true.",
          details2:' In epistemology, philosophers use the term "belief" to refer to attitudes about the world which can be either true or false.',
            details3:'To believe something is to take it to be true; for instance, to believe that snow is white is comparable to accepting the truth of the proposition "snow is white". However, holding a belief does not require active introspection. For example, few carefully consider whether or not the sun will rise tomorrow, simply assuming that it will. Moreover, beliefs need not be occurrent (e.g. a person actively thinking "snow is white"), but can instead be dispositional (e.g. a person who if asked about the color of snow would assert "snow is white").',
          // details4:"ZipRecruiter says that the average frontend developer salary is $94,639 per year, with a low of $37K and a high of $147K.",
          // details5:"Bas
          popUpSources:[
            {
              name:"Belief",
              link:"https://en.wikipedia.org/wiki/Belief",
            },
          ],

        }
        ,
        {
          name:"Worldview",
          details1:"A worldview or world-view is the fundamental cognitive orientation of an individual or society encompassing the whole of the individual's or society's knowledge and point of view.",
          details2:'A worldview can include natural philosophy; fundamental, existential, and normative postulates; or themes, values, emotions, and ethics.',
            details3:"The term worldview is a calque of the German word Weltanschauung [ˈvɛltʔanˌʃaʊ.ʊŋ] (listen), composed of Welt ('world') and Anschauung ('perception' or 'view'). The German word is also used in English.",
           details4:"It is a concept fundamental to German philosophy, especially epistemology and refers to a wide world perception. Additionally, it refers to the framework of ideas and beliefs forming a global description through which an individual, group or culture watches and interprets the world and interacts with it.",
          // details5:"Bas
          popUpSources:[
            {
              name:"Worldview",
              link:"https://en.wikipedia.org/wiki/Worldview",
            },
          ],

        }
        ,
        {
          name:"Religious text",
          details1:"Religious texts, including scripture, are texts which various religions consider to be of central importance to their religious tradition. They differ from literature by being a compilation or discussion of beliefs, mythologies, ritual practices, commandments or laws, ethical conduct, spiritual aspirations, and for creating or fostering a religious community.",
          details2:'"Scripture" (or "scriptures") is a subset of religious texts considered to be "especially authoritative", revered and "holy writ", "sacred, canonical", or of "supreme authority, special status" to a religious community.',
            details3:"The terms sacred text and religious text are not necessarily interchangeable in that some religious texts are believed to be sacred because of the belief in some theistic religions such as the Abrahamic religions that the text is divinely or supernaturally revealed or divinely inspired, or in non-theistic religions such as some Indian religions they are considered to be the central tenets of their eternal Dharma. ",
           details4:'Many religious texts, in contrast, are simply narratives or discussions pertaining to the general themes, interpretations, practices, or important figures of the specific religion. In others (Christianity), the canonical texts include a particular text (Bible) but is "an unsettled question", according to Eugene Nida. In yet others (Hinduism, Buddhism), there "has never been a definitive canon".',
          details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Religious text",
              link:"https://en.wikipedia.org/wiki/Religious_text",
            },
          ],

        }
        ,
        {
          name:"Sacred space",
          details1:"Sacred site, sacred ground, sacred space, holy ground, or holy place refers to a location which is deemed to be sacred or hallowed.",
          details2:'The sacredness of a natural feature may accrue through tradition or be granted through a blessing. One or more religions may consider sacred locations to be of special significance. Often, such locations either are or become the home of sanctuaries, shrines, places of worship, or locations conducive to meditation.',
            details3:"Regardless of construction or use, these areas may have a variety of ritual or taboo associations - including limitations on visitors or on allowed actions within the space. Such places may become the focus of pilgrimage, drawing pilgrims from great distances, or simply locations of significance for the local populace.",
          //  details4:'Many religious texts, in contrast, are simply narratives or discussions pertaining to the general themes, interpretations, practices, or important figures of the specific religion. In others (Christianity), the canonical texts include a particular text (Bible) but is "an unsettled question", according to Eugene Nida. In yet others (Hinduism, Buddhism), there "has never been a definitive canon".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Sacred space",
              link:"https://en.wikipedia.org/wiki/Sacred_space",
            },
          ],

        }
        ,
        {
          name:"Prophecy",
          details1:"In religion, a prophecy is a message that has been communicated to a person (typically called a prophet) by a supernatural entity.",
          details2:'Prophecies are a feature of many cultures and belief systems and usually contain divine will or law, or preternatural knowledge, for example of future events.',
          details3:"They can be revealed to the prophet in various ways depending on the religion and the story, such as visions, divination, or direct interaction with divine beings in physical form. Stories of prophetic deeds sometimes receive considerable attention and some have been known to survive for centuries through oral tradition or as religious texts.",
          //  details4:'Many religious texts, in contrast, are simply narratives or discussions pertaining to the general themes, interpretations, practices, or important figures of the specific religion. In others (Christianity), the canonical texts include a particular text (Bible) but is "an unsettled question", according to Eugene Nida. In yet others (Hinduism, Buddhism), there "has never been a definitive canon".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Prophecy",
              link:"https://en.wikipedia.org/wiki/Prophecy",
            },
          ],

        }
        ,
        {
          name:"Ethics in religion",
          details1:"Ethics involves systematizing, defending, and recommending concepts of right and wrong behavior.",
          details2:'A central aspect of ethics is "the good life", the life worth living or life that is simply satisfying, which is held by many philosophers to be more important than traditional moral conduct.',
            details3:"Most religions have an ethical component, often derived from purported supernatural revelation or guidance. Some assert that religion is necessary to live ethically.",
           details4:'Simon Blackburn states that there are those who "would say that we can only flourish under the umbrella of a strong social order, cemented by common adherence to a particular religious tradition".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Ethics in religion",
              link:"https://en.wikipedia.org/wiki/Ethics_in_religion",
            },
          ],

        }
        ,
        {
          name:"Religious organization",
          details1:"Religious activities generally need some infrastructure to be conducted. For this reason, there generally exist religion-supporting organizations, which are some form of organization that manage:",
          details2:'1.) The upkeep of places of worship, such as mosques, churches, temples, synagogues, chapels and other buildings or meeting places.',
            details3:"2.) The payment of salaries to religious leaders, such as Roman Catholic priests, Hindu priests, Protestant ministers, imams and rabbis.",
           // details4:'Simon Blackburn states that there are those who "would say that we can only flourish under the umbrella of a strong social order, cemented by common adherence to a particular religious tradition".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Religious organization",
              link:"https://en.wikipedia.org/wiki/Religious_organization",
            },
          ],

        }
        ,
        {
          name:"Supernatural",
          details1:"The supernatural is phenomena or entities that are not subject to the laws of nature.",
          details2:'It is derived from Medieval Latin supernaturalis, from Latin super- (above, beyond, or outside of) + natura (nature) Though the corollary term "nature", has had multiple meanings since the ancient world, the term "supernatural" emerged in the medieval period and did not exist in the ancient world',
            // details3:"2.) the payment of salaries to religious leaders, such as Roman Catholic priests, Hindu priests, Protestant ministers, imams and rabbis.",
           // details4:'Simon Blackburn states that there are those who "would say that we can only flourish under the umbrella of a strong social order, cemented by common adherence to a particular religious tradition".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Supernatural",
              link:"https://en.wikipedia.org/wiki/Supernatural",
            },
          ],

        }
        ,
        {
          name:"Transcendence",
          details1:"In religion, transcendence is the aspect of a deity's nature and power that is completely independent of the material universe, beyond all known physical laws.",
          details2:'This is contrasted with immanence, where a god is said to be fully present in the physical world and thus accessible to creatures in various ways. In religious experience, transcendence is a state of being that has overcome the limitations of physical existence, and by some definitions, has also become independent of it.',
            details3:'This is typically manifested in prayer, rituals, meditation, psychedelics and paranormal "visions".',
           // details4:'Simon Blackburn states that there are those who "would say that we can only flourish under the umbrella of a strong social order, cemented by common adherence to a particular religious tradition".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Transcendence",
              link:"https://en.wikipedia.org/wiki/Transcendence_(religion)",
            },
          ],

        }
        ,
        {
          name:"Spirituality",
          details1:"The meaning of spirituality has developed and expanded over time, and various meanings can be found alongside each other.",
          details2:'Traditionally, spirituality referred to a religious process of re-formation which "aims to recover the original shape of man", oriented at "the image of God" as exemplified by the founders and sacred texts of the religions of the world.',
            details3:'In modern times, the term both spread to other religious traditions and broadened to refer to a wider range of experience, including a range of esoteric traditions and religious traditions. Modern usages tend to refer to a subjective experience of a sacred dimension and the "deepest values and meanings by which people live", often in a context separate from organized religious institutions. This may involve belief in a supernatural realm beyond the ordinarily observable world, personal growth, a quest for an ultimate or sacred meaning, religious experience, or an encounter with one\'s own "inner dimension".',
           // details4:'Simon Blackburn states that there are those who "would say that we can only flourish under the umbrella of a strong social order, cemented by common adherence to a particular religious tradition".',
          // details5:'While the term scripture is derived from the Latin scriptura, meaning "writing", most sacred scriptures of the world\'s major religions were originally a part of their oral tradition, and were "passed down through memorization from generation to generation until they were finally committed to writing", according to the Encyclopaedia Britannica.',
          popUpSources:[
            {
              name:"Transcendence",
              link:"https://en.wikipedia.org/wiki/Transcendence_(religion)",
            },
          ],

        }
      ],
      aboutSourceLink:{
                        name:"Read more",
                        link:"https://en.wikipedia.org/wiki/Religion"
                      },
      MainLocation:"Cameroon || southwest || Buea",
      TotalNumberOfBranches:"1",
      OtherLocations:[
        {
          name:"Remote",
          link:"https://msb-geneasocial.herokuapp.com/"
        }
      ],

      JobPost:[
        {
          name:"Religion Teacher",
          location:"Remote/US",
          details:" The average Religion Teacher in the US makes $69,675. Religion Teachers make the most in Dallas at $71,050, averaging total compensation 2% greater than the US average.",
          analysis:{

              status:"Dynamic",
              jobLocation:"Remote/Us",
              details1:"The salaries of Religion Teachers in the US range from $22,800 to $125,050 , with a median salary of $66,380 . The middle 60% of Religion Teachers makes $66,380, with the top 80% making $125,050.",
              popUpSources:[
                {
                  name:"www.comparably.com",
                  link:"https://www.comparably.com/salaries/salaries-for-religion-teacher",
                }
              ]
                },
        },
      ],
      JobPostSources:[
        {
          name:"comparably.com",
          link:"https://www.comparably.com/salaries/salaries-for-religion-teacher"
        },
      ],
      courseLink:"/school/religion"
  }
]
